var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPager
    ? _c(
        "div",
        { staticClass: "v-pager" },
        [
          _c("paginate", {
            ref: "pager",
            attrs: {
              "page-count": _vm.newsList.count,
              "page-range": 3,
              "prev-text": "前へ",
              "next-text": "次へ",
              "container-class": "p-nav-pagination",
              "page-class": "page-item",
              "prev-class": "prev",
              "next-class": "next",
              "active-class": "-active",
              "initial-page": 3,
              "click-handler": _vm.goPage
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }